import { GREY_DROPDOWN_CARET } from '../../../../assets/hostedassets';
import { COLORS } from '../../../../utils/constants/colors';
import type { GradeOptionsByCategory } from './types';

/** ViewConfig column field the Profile Grade chip and its per-value colours come from. */
export const PROFILE_GRADE_FIELD = 'customFields.profileGrade';

// Organization Type and Owner have no per-value colour in the ViewConfig, so they reuse
// the neutral pair the Leads card already gives its owner chip.
export const NEUTRAL_CHIP = {
    backgroundColor: COLORS.LIGHT_BG,
    labelColor: COLORS.BLACK,
    customCaret: GREY_DROPDOWN_CARET,
};

export const NO_GRADE_OPTIONS: GradeOptionsByCategory = { Lender: {}, Partner: {} };
